var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_20415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3819 31.201L30.3103 7.85427C30.273 7.39226 29.8855 7.04202 29.4161 7.04202H25.0493C25.0418 3.15959 21.8822 0 17.9998 0C14.1174 0 10.9578 3.15959 10.9503 7.04202H6.58352C6.12151 7.04202 5.73401 7.39226 5.6893 7.85427L3.61768 31.201C3.61768 31.2308 3.61768 31.2532 3.61768 31.283C3.61768 33.8837 6.00973 36 8.94577 36H27.0538C29.9899 36 32.3819 33.8837 32.3819 31.283C32.3819 31.2532 32.3819 31.2308 32.3819 31.201ZM17.9998 1.78845C20.8986 1.78845 23.2534 4.14324 23.2608 7.04202H12.7388C12.7462 4.14324 15.101 1.78845 17.9998 1.78845ZM27.0538 34.2041H8.94577C7.00828 34.2041 5.42848 32.9149 5.40613 31.3128L7.40323 8.83047H10.9503V11.9677C10.9503 12.4595 11.3527 12.8619 11.8445 12.8619C12.3364 12.8619 12.7388 12.4595 12.7388 11.9677V8.83047H23.2608V11.9677C23.2608 12.4595 23.6632 12.8619 24.155 12.8619C24.6469 12.8619 25.0493 12.4595 25.0493 11.9677V8.83047H28.5964L30.5935 31.3202C30.5711 32.9149 28.9913 34.2041 27.0538 34.2041Z",
    fill: "#00B307"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7183 18.6145L16.4424 23.8904L14.2888 21.7369C13.9385 21.3866 13.3722 21.3866 13.022 21.7369C12.6717 22.0871 12.6717 22.6534 13.022 23.0037L15.809 25.7907C15.9803 25.9621 16.2114 26.0515 16.4424 26.0515C16.6734 26.0515 16.8969 25.9621 17.0758 25.7907L22.9851 19.8813C23.3353 19.5311 23.3353 18.9648 22.9851 18.6145C22.6349 18.2717 22.0685 18.2717 21.7183 18.6145Z",
    fill: "#00B307"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_20415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.35dc4d44a40795c1015e4f527028c1df.svg";
export { ForwardRef as ReactComponent };